/**
 * Единый каркас приложения (§3.4).
 *
 * Шапка, навигация, глобальный поиск, переключатель темы и меню профиля
 * НЕ размонтируются при переходах между разделами: они живут здесь, а
 * маршруты рендерятся в Outlet.
 */

import { Outlet, useLocation } from "react-router-dom";

import { useTopics } from "@taskflow/client-core";
import { ConnectionBanner } from "@/shared/ui/ConnectionBanner";

import { useIsPhone } from "@/shared/lib/media";

import { AppHeader } from "./AppHeader";
import { BottomNav } from "./BottomNav";
import { useAppSelector } from "./hooks";
import { ErrorBoundary } from "./ErrorBoundary";
import { useThemeSync } from "./useThemeSync";

export function AppShell() {
  // Личный поток живёт столько же, сколько каркас: отзыв сессии, отзыв
  // доступа к доске и готовность выгрузки должны доходить с любого экрана.
  const userId = useAppSelector((state) => state.auth.user?.id);
  const location = useLocation();
  useTopics([userId === undefined ? null : `user:${userId}`]);
  // Тема из личных настроек — одна на всех устройствах пользователя.
  useThemeSync();
  const phone = useIsPhone();

  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <AppHeader />
      <ConnectionBanner />

      {/* Отступ снизу — под нижнюю панель телефона, иначе она закрывала
          бы конец страницы. */}
      <main className="flex-1 pb-(--tabbar-h)">
        {/* §3.5: ошибка одной вкладки не должна переключать пользователя
            в другой раздел — граница ставится здесь, а не выше. */}
        {/* resetKey: переход в другой раздел снимает ошибку прежнего — иначе
            она оставалась на экране до перезагрузки страницы. */}
        <ErrorBoundary area="route" resetKey={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>

      {phone && <BottomNav />}
    </div>
  );
}
